/// <amd-module name="Build/Common/Library/Components/UpdateBitbucketServiceConnectionHeader" />
import * as React from "react";

import { BuildDefinition } from "Build/Client/Contracts/Build";
import * as Resources from "Build/Common/Library/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { css, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { IButtonProps } from "VSSUI/Button";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBuildLinkingService } from "Build/Client/Linking";

export interface UpdateBitbucketServiceConnectionHeaderProps extends IVssComponentProperties {
    definition: BuildDefinition;
}

export interface UpgradeServiceConnectionHeaderState {
    bannerClosed: boolean,
    buttonProps: IButtonProps
}

export class UpdateBitbucketServiceConnectionHeader extends VssComponent<UpdateBitbucketServiceConnectionHeaderProps, UpgradeServiceConnectionHeaderState, IVssComponentContext> {
    constructor(props: UpdateBitbucketServiceConnectionHeaderProps, context: IVssComponentContext) {
        super(props, context);

        const linkingService = context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
        const editLink = linkingService.getDefinitionEditUrl(props.definition!.id, "Tab_Tasks")

        const state: UpgradeServiceConnectionHeaderState = {
            bannerClosed: false,
            buttonProps: {
                text: Resources.EditPipeline,
                onClick: () => onClickFPS(this.context.pageContext, editLink, true)
            }
        };

        this.state = state;
    }

    public render(): JSX.Element {
        if (this.state.bannerClosed) {
            return <></>;
        }

        return <div className={css(
            "page-content",
            "flex-row",
            "flex-noshrink",
            this.props.className)}>
            <MessageCard
                className="flex-grow"
                severity={MessageCardSeverity.Error}
                onDismiss={this._closeConnectionCard}
                buttonProps={[this.state.buttonProps]}>
                <FormatComponent format={Resources.UpdateBitBucketConnection} />
            </MessageCard>
        </div>;
    }

    private _closeConnectionCard = () => {
        this.setState({ bannerClosed: true });
    }
}

